import Helmet from 'react-helmet';

function Cennik() {

    return (<>
        <Helmet>
        <title>Cennik - BazaMaili</title>
        <meta name="description" content="Prezentujemy aktualne ceny za pojedynczy wpis. Cena bazy zależy od liczby wpisów oraz wybranego rodzaju danych." />

        </Helmet>
        <div className="container">
                    
                    <br/><br/>   
                       <h3><b><font color="#00539C">Cennik</font></b></h3>
                   
                   <div className="row">
                   <div className="col-md-12">					
                       <img style={{float: 'right'}} src="img/cennik.webp" loading="lazy" alt="cennik"/>	
                   <br/>	
           Cena bazy jest ustalana indywidualnie na podstawie liczby wpisów oraz rodzaju danych wybranych podczas jej generowania. Poniżej znajdują się ceny za pojedynczy wpis.
       <br/><br/>	
           - cena wpisu z podstawowymi danymi: <b><font color="#00539C">0,01 zł</font></b><br/>	
           - cena wpisu z adresem email: <b><font color="#00539C">0,05 zł</font></b><br/>
           - cena wpisu z numerem telefonu: <b><font color="#00539C">0,07 zł</font></b><br/>
           - cena wpisu z obiema formami kontaktu: <b><font color="#00539C">0,10 zł</font></b><br/>			
       <br/>	
         Informujemy, że niemal każdy wpis zawiera podstawowe dane, takie jak imię i nazwisko właściciela firmy, NIP, REGON, nazwę firmy, datę rozpoczęcia działalności, kody TERC, SIMC i ULIC, a także szczegółowe dane adresowe: gminę, ulicę, numer budynku, kod pocztowy, dzielnicę, miejscowość, powiat i województwo. Wpis może również zawierać ID, numer identyfikacyjny oraz adres strony internetowej.	
         Za pojedynczy wpis zawierający wymienione wyżej dane zapłacisz jedynie 1 grosz. Wpis zawierający dodatkowo adres email kosztuje 5 groszy, wpis z numerem telefonu 7 groszy, a za wpis zawierający zarówno adres email, jak i numer telefonu zapłacisz 10 groszy.
        <br/>				
                   
                   </div>  
                   </div>
               </div>

    </>);
}

export default Cennik;